export default __webpack_public_path__ + "static/media/img-contacto-2.851f1c77.jpg";